import { render } from "./Videos.vue?vue&type=template&id=6ba1d480&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6ba1d480"

export default script